import { parseAccount } from '../../accounts/utils/parseAccount.js';
import { AccountNotFoundError } from '../../errors/account.js';
import { toHex } from '../../utils/encoding/toHex.js';
export async function signMessage(client, { account: account_ = client.account, message, }) {
    if (!account_)
        throw new AccountNotFoundError({
            docsPath: '/docs/actions/wallet/signMessage',
        });
    const account = parseAccount(account_);
    if (account.type === 'local')
        return account.signMessage({ message });
    return client.request({
        method: 'personal_sign',
        params: [toHex(message), account.address],
    });
}
//# sourceMappingURL=signMessage.js.map